import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AgentConfigAssistant } from '@components/agents';

export const Route = createFileRoute('/_dashboard/agents')({
  component: AgentsLayout,
});

function AgentsLayout() {
  return (
    <>
      <Outlet />
      <AgentConfigAssistant />
    </>
  );
}
